import axios, { AxiosRequestConfig } from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { DueDateInputDTO, DueDateMethodByBusinessUnitInputDTO, DueDateMethodByBusinessUnitOutputDTO, DueDateMethodByWorkUnitInputDTO, DueDateMethodByWorkUnitOutputDTO, DueDateMethodOutputDTO, DueDateOutputDTO, DueDateRangeOutputDTO } from './dueDateDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'

class DueDateServices {
  async getByAllDueDateRange(params: any): Promise<DueDateRangeOutputDTO[]> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }

      if (params) {
        config.params = params
      }
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/due-date-range/`, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getByAllDueDateMethod(params: any): Promise<DueDateMethodOutputDTO[]> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }

      if (params) {
        config.params = params
      }
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/due-date-method/`, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getByIdDueDateMethod(id: number): Promise<DueDateMethodOutputDTO> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/due-date-method/${id}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async createDateRange(data: DueDateInputDTO): Promise<DueDateOutputDTO> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }
      const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/date-range/`, data, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateDateRange(id: number, data: DueDateInputDTO): Promise<DueDateOutputDTO> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }
      const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/date-range/${id}`, data, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteDateRange(id: number): Promise<number> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }
      const res = await axios.delete(`${process.env.REACT_APP_URL_RESERVATION}/date-range/${id}`, config)
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async createDueDateMethodByWorkUnit(
    data: DueDateMethodByWorkUnitInputDTO
  ): Promise<DueDateMethodByWorkUnitOutputDTO> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/work-unit-due-date-by-product/`,
        data,
        config
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async createDueDateMethodByBusinessUnit(
    data: DueDateMethodByBusinessUnitInputDTO
  ): Promise<DueDateMethodByBusinessUnitOutputDTO> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/business-unit-due-date-by-product/`,
        data,
        config
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getDueDateMethodByWorkUnit(params: any): Promise<DueDateMethodByWorkUnitOutputDTO[]> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }

      if (params) {
        config.params = params
      }
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/work-unit-due-date-by-product/`,
        config
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteDueDateMethodByWorkUnit(
    due_date_method_id: number,
    work_unit_id: number,
    product_id?: number
  ): Promise<number> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
        params: product_id ? { product_id } : null,
      }
      const res = await axios.delete(
        `${process.env.REACT_APP_URL_RESERVATION}/work-unit-due-date-by-product/${due_date_method_id}/${work_unit_id}/`,
        config
      )
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getDueDateMethodByBusinessUnit(params: any): Promise<DueDateMethodByBusinessUnitOutputDTO[]> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }

      if (params) {
        config.params = params
        config.params.limit = 200
      }
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/business-unit-due-date-by-product/`,
        config
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteDueDateMethodByBusinessUnit(
    due_date_method_id: number,
    business_unit_id: number,
    product_id?: number
  ): Promise<number> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
        params: product_id ? { product_id } : null,
      }
      const res = await axios.delete(
        `${process.env.REACT_APP_URL_RESERVATION}/business-unit-due-date-by-product/${due_date_method_id}/${business_unit_id}/`,
        config
      )
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}
export const dueDateServices = new DueDateServices()
